import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { useSnackbar } from "notistack";

import useStyle from "./styles";
import globalUseStyles from "../../../styles";
import moment from "moment";

const DialogDataInicioFim = (props) => {
  const classes = useStyle();
  const globalClasses = globalUseStyles();
  const { enqueueSnackbar } = useSnackbar();

  const { open, onClose, tituloSubtitulo, onSubmitExternal, dataInicioFornecida, dataFimFornecida, isDisponibilizar = false } = props;
 
  const dataInicial = isDisponibilizar ? moment().add(1,'days').format("YYYY-MM-DD") : moment(dataInicioFornecida).format("YYYY-MM-DD")
  const dataFinal = isDisponibilizar ? getProxDiaUtil(moment(), 5, feriadosNacionaisBrasil) : moment(dataFimFornecida).format("YYYY-MM-DD")

  const [dataInicio, setDataInicio] = useState(dataInicial);
  const [dataLimite, setDataLimite] = useState(dataFinal);

  const onSubmit = () => {
    event.preventDefault();
    onSubmitExternal(dataInicio, dataLimite);
  };

  const handleButtonDataInicioFimCancelar = () => {
    onClose(false);
  };

  const handleDataInicioChange = (event) => {
    setDataInicio(event.target.value);

  };

  const handleDataLimiteChange = (event) => {
    setDataLimite(event.target.value);
  };
  
  return (
    <Dialog open={open} onClose={onClose}>
      <form onSubmit={onSubmit}>
        <DialogTitle>
          <Typography className={globalClasses.tituloDialog}>
            {tituloSubtitulo.titulo}
          </Typography>
          <Typography className={globalClasses.tituloDialog}>
            {tituloSubtitulo.subtitulo}
          </Typography>
          <IconButton
            className={globalClasses.closeButtonDialog}
            onClick={handleButtonDataInicioFimCancelar}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid className={classes.gridDataInicio}>
            <Grid>
              <TextField
                label="Data início"
                type="date"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={dataInicio}
                disabled={!!!isDisponibilizar}
                onChange={handleDataInicioChange}
                inputProps={
                  !!isDisponibilizar && {min: moment().format("YYYY-MM-DD")}
                }
              />
            </Grid>
            <Grid>
              <TextField
                inputProps={
                  !!isDisponibilizar ?
                  {min: moment().add(1,'days').format("YYYY-MM-DD")} :
                  {min: dataFinal}
                }
                value={dataLimite}
                variant="outlined"
                label="Data limite"
                type="date"
                InputLabelProps={{ shrink: true }}
                onChange={handleDataLimiteChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button variant="contained" type="submit">
            Salvar
          </Button>
          <Button variant="outlined" color="primary" onClick={onClose}>
            Cancelar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default DialogDataInicioFim;

const feriadosNacionaisBrasil = [
  '2024-01-01', // New Year's Day
  '2024-02-25', // Carnival
  '2024-02-26', // Carnival
  '2024-04-21', // Tiradentes' Day
  '2024-05-01', // Labor Day
  '2024-06-20', // Corpus Christi
  '2024-09-07', // Independence Day
  '2024-10-12', // Our Lady of Aparecida - Patroness of Brazil
  '2024-11-02', // All Souls' Day
  '2024-11-15', // Republic Day
  '2024-12-25', // Christmas Day

  '2025-01-01', // New Year's Day
  '2025-02-17', // Carnival
  '2025-02-18', // Carnival
  '2025-04-21', // Tiradentes' Day
  '2025-05-01', // Labor Day
  '2025-06-05', // Corpus Christi
  '2025-09-07', // Independence Day
  '2025-10-12', // Our Lady of Aparecida - Patroness of Brazil
  '2025-11-02', // All Souls' Day
  '2025-11-15', // Republic Day
  '2025-12-25', // Christmas Day

  '2026-01-01', // New Year's Day
  '2026-02-09', // Carnival
  '2026-02-10', // Carnival
  '2026-04-21', // Tiradentes' Day
  '2026-05-01', // Labor Day
  '2026-05-28', // Corpus Christi
  '2026-09-07', // Independence Day
  '2026-10-12', // Our Lady of Aparecida - Patroness of Brazil
  '2026-11-02', // All Souls' Day
  '2026-11-15', // Republic Day
  '2026-12-25', // Christmas Day
];

const getProxDiaUtil = (dataInicial, diasUteisAFrente, listaFeriados) => {
  let dataAtual = moment(dataInicial)
  let diasAdicionados = 0

  while( diasAdicionados < diasUteisAFrente ) {
    dataAtual.add(1,'days')

    if(dataAtual.day() !== 0 && dataAtual.day() !== 6 && !listaFeriados.includes(dataAtual.format('YYYY-MM-DD'))) {
      diasAdicionados++
    }
  }

  return dataAtual.format('YYYY-MM-DD')
}